import * as Types from '@x/schemas/ecommerce';

import { gql } from 'apollo-angular';
import { ShopProductItemAttributesFragmentDoc } from './shop-product.gql.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ShopWishListItemFragment = { __typename: 'ShopProductWishlistItemObject', id: number, createdAt: any, productId: number, updatedAt: any, product: { __typename: 'ShopProductObject', id: number, slug: string, name: string, shortDescription?: string | null | undefined, contentRef?: string | null | undefined, priority: number, variation: Types.ProductVariation, mainTaxonId: number, thumbnailBase64?: string | null | undefined, hidden: boolean, mainTaxon: { __typename: 'ShopTaxonObject', slug: string }, mainMedia?: { __typename: 'ShopProductMediaObject', url: string, type: string, variantId?: number | null | undefined } | null | undefined, secondaryMedia?: { __typename: 'ShopProductMediaObject', url: string, type: string, variantId?: number | null | undefined } | null | undefined, variants: Array<{ __typename: 'ShopProductVariantObject', id: number, slug: string, name: string, description?: string | null | undefined, capAmount?: number | null | undefined, available: boolean, optionValues: Array<{ __typename: 'ShopProductVariantOptionValueObject', optionId: number, id: number }>, price: { __typename: 'ShopCurrencyObject', currency: string, amount: number }, availableRegions: Array<{ __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined }>, regions?: Array<{ __typename: 'ShopProductVariantRegionObject', nextAvailableDate?: any | null | undefined, nextAvailableQuantity?: number | null | undefined, isAvailable: boolean, unavailableReason?: Types.ShopProductUnavailableReason | null | undefined, region: { __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined } }> }>, options: Array<{ __typename: 'ShopProductOptionObject', id: number, name: string, values: Array<{ __typename: 'ShopProductOptionValueObject', id: number, name: string }> }>, taxons: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }>, badges: Array<{ __typename: 'ShopTaxonBadgeObject', id: number, name: string, badgeIconUrl?: string | null | undefined }>, membershipRequirements: Array<{ __typename: 'ShopMembershipObject', id: number, name: string, activationUrl?: string | null | undefined }>, searchContext: { __typename: 'ShopProductSearchContextObject', objectId: string, queryIndex: string } } };

export type ShopWishListItemsQueryVariables = Types.Exact<{
  channelCode: Types.Scalars['String']['input'];
  locale: Types.Scalars['String']['input'];
  regionId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  page?: Types.InputMaybe<Types.ShopPageInput>;
  sort?: Types.InputMaybe<Types.ShopSortInput>;
  includeRegion?: Types.Scalars['Boolean']['input'];
}>;


export type ShopWishListItemsQuery = { __typename: 'Query', totalItemsCount: number, items: Array<{ __typename: 'ShopProductWishlistItemObject', id: number, createdAt: any, productId: number, updatedAt: any, product: { __typename: 'ShopProductObject', id: number, slug: string, name: string, shortDescription?: string | null | undefined, contentRef?: string | null | undefined, priority: number, variation: Types.ProductVariation, mainTaxonId: number, thumbnailBase64?: string | null | undefined, hidden: boolean, mainTaxon: { __typename: 'ShopTaxonObject', slug: string }, mainMedia?: { __typename: 'ShopProductMediaObject', url: string, type: string, variantId?: number | null | undefined } | null | undefined, secondaryMedia?: { __typename: 'ShopProductMediaObject', url: string, type: string, variantId?: number | null | undefined } | null | undefined, variants: Array<{ __typename: 'ShopProductVariantObject', id: number, slug: string, name: string, description?: string | null | undefined, capAmount?: number | null | undefined, available: boolean, optionValues: Array<{ __typename: 'ShopProductVariantOptionValueObject', optionId: number, id: number }>, price: { __typename: 'ShopCurrencyObject', currency: string, amount: number }, availableRegions: Array<{ __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined }>, regions?: Array<{ __typename: 'ShopProductVariantRegionObject', nextAvailableDate?: any | null | undefined, nextAvailableQuantity?: number | null | undefined, isAvailable: boolean, unavailableReason?: Types.ShopProductUnavailableReason | null | undefined, region: { __typename: 'ShopGeoRegionObject', id: number, name: string, code: string, channelCode: string, channelId: number, parentId?: number | null | undefined, label?: string | null | undefined, description?: string | null | undefined } }> }>, options: Array<{ __typename: 'ShopProductOptionObject', id: number, name: string, values: Array<{ __typename: 'ShopProductOptionValueObject', id: number, name: string }> }>, taxons: Array<{ __typename: 'ShopTaxonObject', id: number, parentId?: number | null | undefined, position: number, name: string, slug: string, badge: boolean, productCount: number, descendentProductCount: number, channelCode: string, hidden: boolean, path: string, contentRef?: string | null | undefined }>, badges: Array<{ __typename: 'ShopTaxonBadgeObject', id: number, name: string, badgeIconUrl?: string | null | undefined }>, membershipRequirements: Array<{ __typename: 'ShopMembershipObject', id: number, name: string, activationUrl?: string | null | undefined }>, searchContext: { __typename: 'ShopProductSearchContextObject', objectId: string, queryIndex: string } } }> };

export type ShopWishListItemIdsQueryVariables = Types.Exact<{
  channelCode: Types.Scalars['String']['input'];
  userId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  page?: Types.InputMaybe<Types.ShopPageInput>;
}>;


export type ShopWishListItemIdsQuery = { __typename: 'Query', shopWishlistItems: Array<{ __typename: 'ShopProductWishlistItemObject', productId: number }> };

export type ShopAddWishlistItemMutationVariables = Types.Exact<{
  productId: Types.Scalars['Int']['input'];
}>;


export type ShopAddWishlistItemMutation = { __typename: 'Mutation', shopAddWishlistItem: { __typename: 'ShopProductWishlistItemObject', productId: number } };

export type ShopRemoveWishlistItemMutationVariables = Types.Exact<{
  productId: Types.Scalars['Int']['input'];
}>;


export type ShopRemoveWishlistItemMutation = { __typename: 'Mutation', shopRemoveWishlistItem: number };

export const ShopWishListItemFragmentDoc = gql`
    fragment ShopWishListItem on ShopProductWishlistItemObject {
  id
  createdAt
  productId
  updatedAt
  productId
  product(locale: $locale, channelCode: $channelCode) {
    ...ShopProductItemAttributes
  }
}
    ${ShopProductItemAttributesFragmentDoc}`;
export const ShopWishListItemsDocument = gql`
    query ShopWishListItems($channelCode: String!, $locale: String!, $regionId: Int, $page: ShopPageInput, $sort: ShopSortInput, $includeRegion: Boolean! = false) {
  items: shopWishlistItems(
    channelCode: $channelCode
    regionId: $regionId
    page: $page
    sort: $sort
  ) {
    ...ShopWishListItem
  }
  totalItemsCount: shopWishlistItemsCount(
    channelCode: $channelCode
    regionId: $regionId
  )
}
    ${ShopWishListItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopWishListItemsGQL extends Apollo.Query<ShopWishListItemsQuery, ShopWishListItemsQueryVariables> {
    document = ShopWishListItemsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopWishListItemIdsDocument = gql`
    query ShopWishListItemIds($channelCode: String!, $userId: Int, $page: ShopPageInput) {
  shopWishlistItems(channelCode: $channelCode, userId: $userId, page: $page) {
    productId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopWishListItemIdsGQL extends Apollo.Query<ShopWishListItemIdsQuery, ShopWishListItemIdsQueryVariables> {
    document = ShopWishListItemIdsDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopAddWishlistItemDocument = gql`
    mutation ShopAddWishlistItem($productId: Int!) {
  shopAddWishlistItem(productId: $productId) {
    productId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopAddWishlistItemGQL extends Apollo.Mutation<ShopAddWishlistItemMutation, ShopAddWishlistItemMutationVariables> {
    document = ShopAddWishlistItemDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShopRemoveWishlistItemDocument = gql`
    mutation ShopRemoveWishlistItem($productId: Int!) {
  shopRemoveWishlistItem(productId: $productId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ShopRemoveWishlistItemGQL extends Apollo.Mutation<ShopRemoveWishlistItemMutation, ShopRemoveWishlistItemMutationVariables> {
    document = ShopRemoveWishlistItemDocument;
    client = 'ecommerce';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }